import { useCallback, useEffect, useState } from 'react';
import { LOCAL_STORAGE_SETTINGS_KEY } from '@frodo/lib/utils/common/constants';

let settings: Record<string, string> = {};

type UseLocalStorageType = [state: string, setValue: (value: string) => void];

export const useLocalStorage = (property: string): UseLocalStorageType => {
  const [state, setState] = useState('[]');

  useEffect(() => {
    const value =
      window?.localStorage.getItem(LOCAL_STORAGE_SETTINGS_KEY) || '{}';
    settings = JSON.parse(value) as Record<string, string>;
    setState(settings[property] ?? '[]');
  }, [property]);

  const setValue = useCallback(
    (value: string) => {
      try {
        const storedValue =
          window?.localStorage.getItem(LOCAL_STORAGE_SETTINGS_KEY) || '{}';
        settings = JSON.parse(storedValue) as Record<string, string>;

        if (!value || value === '') {
          delete settings[property];
        } else {
          settings[property] = value;
        }
        localStorage.setItem(
          LOCAL_STORAGE_SETTINGS_KEY,
          JSON.stringify(settings),
        );
        setState(value);
      } catch (error) {
        console.log(error);
      }
    },
    [property],
  );

  return [state, setValue];
};
